/*
 * Copyright (c) 2023. Data Smart Technologies CC
 * https://www.datasmart.co.za
 * View license agreement and terms of use at https://www.datasmart.co.za/legal
 *
 * @author  Juan <juan@datasmart.co.za>
 * @version 1.0
 * @updated 2023-07-11
 */

import React from "react";
import { SearchDeceasedRecord } from "../components/SearchDeceasedRecord";
import { Helmet } from "react-helmet";

export const Search: React.FC = () => {
    return(
        <>
            <Helmet>
                <title>Search - Jewish Cemetery</title>
                <meta name="description" content="This website was designed by the Jewish Cemeteries Maintenance Board to pay tribute to loved ones that are no longer with us." />
            </Helmet>

            <div className="jc-grid mx-auto" style={{maxWidth: "1028px"}}>
                <div className="search-wrapper">
                    <SearchDeceasedRecord />
                </div>
            </div>
        </>
    );
}